import React, { Component } from "react";
import navarrow from "../assets/back_btn.png";
import closeMark from '../assets/revamp-assets/closeMark.png'
import uparrow from "../assets/uparrow.png"
import downarrow from "../assets/downarrow.png"
import { connect } from "react-redux";
import {
  toggleModalAction,
  toggleAlertAction,
  getFailedTranscatiosData,
  getRecheckFailedTranscatiosData,
  getTpslRecheckFailedTranscatiosData,
  getRazorpayRecheckData
} from "../redux/actions/userAction";
import Loading from "../models/Loading";
import ReactPaginate from 'react-paginate';
import './Pagination.css'
import failed from "../assets/failed.png";
import addcashpending from "../assets/pending.png"
import leftarrow from "../assets/tsleftarrow.png"
import rightarrow from "../assets/tsrightarrow.png"
import forfeited from "../assets/forfeited.png"
import redeempending from "../assets/redeempending.png";
import { TS_STRINGS, KYC_DOCUMENTS } from "../Strings";
import VerificationAlert from "../models/VerificationAlert";
import { Link } from "react-router-dom";
import { WebToNativeMessage } from "../Common/Utils";
class FailedTranscations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      failedtnxhistoryData: [],
      isloading: true,
      token: "",
      channel: window.sessionStorage["channel"],
      order_id: "",
      rechecktranscationRes: [],
      openCard: false,
      activePage: 1,
      totalRecordsPerPage: 20,
      //openCard: false,
      isShowPagination: false,
      TranscationsList: [],
      offset: 0,
      data: [],
      perPage: 20,
      currentPage: 0,
      transcationSummeryData: [],
      //data: [],
      pageNumbers: 0,
      isShowPaymentsData: false,
      isshowDetails: false,
      orderId: "",
      currentStatus: "",
      userId: "",
      isuserhaveTDSWinnings: false,
      isPlayStoreChannel: false
    }
    this.handlebackbtn = this.handlebackbtn.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.showKYCStatusAlert = this.showKYCStatusAlert.bind(this);
  }

  async componentWillMount() {
    // console.log("props in componentWillMount failedtransactions::", this.props, "....", this.props.location.data);
    // if (this.props.location.data !== undefined && this.props.location.data !== "") {
      // this.props.location.data.sendCTEvent();
    // }
  }

  //Check if given Number is Integer or float
  checkforIntegerNumber = (num) => {
    if (typeof num == 'number' && !isNaN(num)) {
      if (Number.isInteger(num)) {
        return num;
      } else {
        return num.toFixed(2);
      }
    } else {
      return parseInt(num).toFixed(2);
    }
  }
  dataToClient(object) {
    console.log("Data in Failed Transactions:::", object)
    var data = JSON.parse(object);
    console.log("Data in Failed Transactions::: 2", data.hasOwnProperty("appVersion"), data.hasOwnProperty("channel"), data.hasOwnProperty("token"), data.hasOwnProperty("channelCheckForRedeem"), window.sessionStorage["token"], this.state.token, data.hasOwnProperty("type"), data.hasOwnProperty("body"))
    //console.log("data in object: object",object.hasOwnProperty("appVersion") ,  object.hasOwnProperty("channel"), object.hasOwnProperty("token"),data.hasOwnProperty("channelCheckForRedeem"),window.sessionStorage["token"],this.state.token)
    if (data.hasOwnProperty("appVersion") || data.hasOwnProperty("channel") || data.hasOwnProperty("token")) {
      this.getFailedTransactionsDataFromURL(data)
    } else {
      window.sessionStorage["kycStatus"] = data.body
      window.sessionStorage["panStatus"] = data.panStatus
      window.sessionStorage["kycDocumentNumber"] = data.kycDocNumber
      if (window.sessionStorage["channel"] == "GAPS" || window.sessionStorage["channel"] == "GFPS") {
        this.setState({ isPlayStoreChannel: true })
      } else {
        this.setState({ isPlayStoreChannel: false })
      }
    }
  }

  //to get the transaction type
  getTrasactionType = (type) => {
    switch (type) {
      case "PENDING":
        return "PENDING"
      case "TXN_FAILURE":
        return "TXN_FAILURE"
      case "won_forfeited":
        return "won_forfeited"
      case "withdraw-processing":
        return "withdraw-processing"
      case "win_pending":
        return "win_pending"
      case "withdraw-cancelled":
        return "withdraw-cancelled"
      case "OPEN":
        return "OPEN"
      default:
        return "failed"
    }
  }

  //checking for win pendings:
  //Checking for pending Bonus is having or Not
  checkforTDSWinnings = (arr) => {
    if (arr && arr !== undefined && arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        console.log("wager ratio:::", arr[i].pend);
        if (arr[i].status == "win_pending") {
          this.setState({ isuserhaveTDSWinnings: true })
          break;
        } else {
          this.setState({ isuserhaveTDSWinnings: false })
          //this.setState({isBonusRatiosEqual:false});
        }
      }
    } else {
      this.setState({ isuserhavePandingBonus: false })
    }
  }

  handlebackbtn = () => {
    console.log("backbutton click in failed transactions", this.props.location.from)
    if (this.props.location.from !== undefined && this.props.location.from !== "" && this.props.location.from === "transactionSummary") {
      this.props.history.push("/transactionsummary/")
    } else {
      WebToNativeMessage({ type: "closeClient" })
    }
    //this.props.history.goBack()
  }

  toggleCard = id => {
    this.setState(this.state.openCard === id ? { openCard: false } : { openCard: id })
  }

  async handlefailedRequestAPICall() {
    this.setState({ token: window.sessionStorage["token"] })
    this.setState({ channel: window.sessionStorage["channel"] })
    await this.props.getFailedTranscatiosData(window.sessionStorage["token"], window.sessionStorage["userid"])
    const { failedTranscations } = this.props.userState;
    if (failedTranscations.error) {
      console.log("failed transcations details error::::", failedTranscations.error);
      this.setState({
        errors: { message: failedTranscations.error.message },
        isloading: false
      })
      //this.toggleAlertAction(true, failedTranscations.error.message)
    } else {
      console.log("failed Transcations success::::", failedTranscations);
      this.setState({
        failedtnxhistoryData: failedTranscations,
        isloading: false

      });

      //this.checkforTDSWinnings(failedTranscations)
    }

    //Apxor ScreenName Events  Start
    var screenValue = "";
    if (window.sessionStorage["channel"] == "A23APS" || window.sessionStorage["channel"] == "A23IPS") {
      screenValue = "P_PendingFailedTransactions";
    } else if (window.sessionStorage["channel"] == "FAPS" || window.sessionStorage["channel"] == "FIPS") {
      screenValue = "FS_P_PendingFailedTransactions";
    } else {
      screenValue = "R_PendingFailedTransactions"
    }
    if (window.sessionStorage !== undefined) {
      WebToNativeMessage({ type: "screenNameEvent", screenName: screenValue })
    }
    //Apxor ScreenName Events End
    this.handlereceivedData();
  }

  //For Pagination 

  async handlereceivedData() {
    //for Sorting
    const sortedArray = this.state.failedtnxhistoryData.sort((x, y) => x.createdAt > y.createdAt ? -1 : 1)
    if (sortedArray.length > 0) {
      console.log("TS details Pagination True::::");
      const slice = sortedArray.slice(this.state.offset, this.state.offset + this.state.perPage)
      this.setState({ pageNumbers: Math.ceil(sortedArray.length / this.state.totalRecordsPerPage), TranscationsList: slice })
    } else {
      console.log("TS details Pagination false::::");
      this.setState({ isShowPagination: false })
    }
    if (sortedArray.length > 20) {
      this.setState({ isShowPagination: true })
    } else {
      this.setState({ isShowPagination: false })
    }
  }
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;
    this.setState({
      currentPage: selectedPage,
      offset: offset,
      openCard: false
    }, () => {
      this.handlereceivedData()
    });
  };


  getFailedTransactionsDataFromURL = async (data) => {
    await this.props.getFailedTranscatiosData(data.token, data._id)
    const { failedTranscations } = this.props.userState;
    if (failedTranscations.error) {
      console.log("failed transcations details error::::", failedTranscations.error);
      await this.setState({
        errors: { message: failedTranscations.error.message },
        isloading: false
      })
      //this.toggleAlertAction(true, failedTranscations.error.message)
    } else {
      console.log("failed Transcations success::::", failedTranscations);
      await this.setState({
        failedtnxhistoryData: failedTranscations,
        isloading: false,
      });
      this.setState({ token: data.token, channel: data.channel, userId: data._id })
      window.sessionStorage["token"] = data.token;
      window.sessionStorage["channel"] = data.channel;
      window.sessionStorage["userid"] = data._id;
      window.sessionStorage["kycStatus"] = data.kycStatus;
      window.sessionStorage["panStatus"] = data.panStatus;
      window.sessionStorage["kycDocumentNumber"] = data.kycDocNumber;
      if (window.sessionStorage["channel"] == "GAPS" || window.sessionStorage["channel"] == "GFPS") {
        this.setState({ isPlayStoreChannel: true })
      } else {
        this.setState({ isPlayStoreChannel: false })
      }
      //this.checkforTDSWinnings(failedTranscations)
      //Apxor ScreenName Events  Start
      var screenValue = "";
      if (window.sessionStorage["channel"] == "A23APS" || window.sessionStorage["channel"] == "A23IPS") {
        screenValue = "P_PendingFailedTransactions";
      } else if (window.sessionStorage["channel"] == "FAPS" || window.sessionStorage["channel"] == "FIPS") {
        screenValue = "FS_P_PendingFailedTransactions";
      } else {
        screenValue = "R_PendingFailedTransactions"
      }
      if (window.sessionStorage !== undefined) {
        WebToNativeMessage({ type: "screenNameEvent", screenName: screenValue })
      }
      //Apxor ScreenName Events End
      this.handlereceivedData();
    }
  }

  //Showing KYC SUBMITTED PENDING STATE ALERT

  showKYCStatusAlert() {
    this.props.toggleModalAction(
      true,
      <VerificationAlert
        header={KYC_DOCUMENTS.KEY_KYC_DOCUMENTS_SUBMIITTED_HEADER}
        body={KYC_DOCUMENTS.KEY_KYC_SUBMITTED_BODY}
        btntext={KYC_DOCUMENTS.KEY_KYC_SUBMITTED_BTN_TEXT}
      ></VerificationAlert>, true
    );
  }

  //SHOWING KYC SUBMITTED PENDING STATE ALERT

  async componentDidMount() {
    //for Dynamic Token
    //this.setState({token:window.sessionStorage["token"]})
    //this.setState({channel:window.sessionStorage["channel"]})
    if (window.sessionStorage["token"] !== undefined) {
      if (this.state.token === "") {
        this.getFailedTransactions()
      }
    }
  }

  getFailedTransactions = async () => {
    await this.props.getFailedTranscatiosData(window.sessionStorage["token"], window.sessionStorage["userid"])
    const { failedTranscations } = this.props.userState;
    if (failedTranscations.error) {
      console.log("failed transcations details error::::", failedTranscations.error);
      await this.setState({
        errors: { message: failedTranscations.error.message },
        isloading: false
      })
      //this.toggleAlertAction(true, failedTranscations.error.message)
    } else {
      console.log("failed Transcations success::::", failedTranscations);
      await this.setState({
        failedtnxhistoryData: failedTranscations,
        isloading: false,
      });
      //Apxor ScreenName Events  Start
      var screenValue = "";
      if (window.sessionStorage["channel"] == "A23APS" || window.sessionStorage["channel"] == "A23IPS") {
        screenValue = "P_PendingFailedTransactions";
      } else if (window.sessionStorage["channel"] == "FAPS" || window.sessionStorage["channel"] == "FIPS") {
        screenValue = "FS_P_PendingFailedTransactions";
      } else {
        screenValue = "R_PendingFailedTransactions"
      }
      if (window.sessionStorage !== undefined) {
        WebToNativeMessage({ type: "screenNameEvent", screenName: screenValue })
      }
      //Apxor ScreenName Events End
      //this.checkforTDSWinnings(failedTranscations)
      this.handlereceivedData();
    }
  }

  //Justpay Recheck API Recheck API Call

  async handlejustPayRechecktrasctionAPI(order_id) {
    console.log("justPay:::OrderId::::", order_id);

    await this.props.getRecheckFailedTranscatiosData(window.sessionStorage["token"], order_id)
    const { rechecktranscation } = this.props.userState;
    if (rechecktranscation.error) {
      console.log("failed transcations details error::::", rechecktranscation.error);
      await this.setState({
        errors: { message: rechecktranscation.error.message },
        isloading: false,
        currentStatus: rechecktranscation.error.message
      })
      //this.handlefailedRequestAPICall()
    } else {
      console.log("failed Transcations success::::", rechecktranscation);
      await this.setState({
        rechecktranscationRes: rechecktranscation,
        isloading: false,
        isshowDetails: true,
        currentStatus: rechecktranscation.transactionStatus

      });

      this.handlefailedRequestAPICall()

      console.log("failed transactions recheck current status::", this.state.currentStatus)

      if (this.state.currentStatus !== "" && this.state.currentStatus !== "undefined") {
        if (this.state.currentStatus === "PENDING") {
          this.props.toggleAlertAction(true, "Transaction Pending, Check status later", 2000, "bg-red");
        } else if (this.state.currentStatus === "TXN_SUCCESS") {
          this.props.toggleAlertAction(true, "Transaction Successful. Check your Account Statement.", 2000, "bg-green");
        } else {
          this.props.toggleAlertAction(true, "Transaction Failed", 2000, "bg-red");
        }

      } else {
        if (rechecktranscation.error.message) {
          this.props.toggleAlertAction(true, rechecktranscation.error.message, 2000, "bg-red");
        } else {
          this.props.toggleAlertAction(true, "Error", 2000, "bg-red");
        }

      }
    }

  }

  //TPSL Recheck API Call
  async handleTPSLRechecktrasctionAPI(pgChannel, order_id) {
    console.log("TPSL:::OrderId,pgChannel::::", pgChannel, order_id);

    await this.props.getTpslRecheckFailedTranscatiosData(window.sessionStorage["token"], order_id, pgChannel)
    const { tpslrechecktranscation } = this.props.userState;
    if (tpslrechecktranscation.error) {
      console.log("failed transcations details error::::", tpslrechecktranscation.error);
      await this.setState({
        errors: { message: tpslrechecktranscation.error.message },
        isloading: false,
        currentStatus: tpslrechecktranscation.error.message
      })
      //this.handlefailedRequestAPICall()
    } else {
      console.log("failed Transcations success::::", tpslrechecktranscation);
      await this.setState({
        rechecktranscationRes: tpslrechecktranscation,
        isloading: false,
        isshowDetails: true,
        currentStatus: tpslrechecktranscation.transactionStatus

      });
      this.handlefailedRequestAPICall()

      console.log("failed transactions recheck current status::", this.state.currentStatus)

      if (this.state.currentStatus !== "" && this.state.currentStatus !== "undefined") {
        if (this.state.currentStatus === "PENDING") {
          this.props.toggleAlertAction(true, "Transaction Pending, Check status later", 2000, "bg-red");
        } else if (this.state.currentStatus === "TXN_SUCCESS") {
          this.props.toggleAlertAction(true, "Transaction Successful. Check your Account Statement.", 2000, "bg-green");
        } else {
          this.props.toggleAlertAction(true, "Transaction Failed", 2000, "bg-red");
        }

      } else {
        if (tpslrechecktranscation.error.message) {
          this.props.toggleAlertAction(true, tpslrechecktranscation.error.message, 2000, "bg-red");
        } else {
          this.props.toggleAlertAction(true, "Error", 2000, "bg-red");
        }
      }
    }

  }

  //Added Code For Razorpay New API Changes
  //RazorPay Recheck API Call
  async handleRazorpayRechecktrasctionAPI(pgChannel, order_id) {
    console.log("razorpay:::OrderId::::", order_id);
    await this.props.getRazorpayRecheckData(window.sessionStorage["token"], order_id)
    const { razorpayrecheckData } = this.props.userState;
    if (razorpayrecheckData.error) {
      console.log("failed transcations details error::::", razorpayrecheckData.error);
      await this.setState({
        errors: { message: razorpayrecheckData.error.message },
        isloading: false,
        currentStatus: razorpayrecheckData.error.message
      })
      //this.handlefailedRequestAPICall()
    } else {
      console.log("failed Transcations success::::", razorpayrecheckData);
      await this.setState({
        rechecktranscationRes: razorpayrecheckData,
        isloading: false,
        isshowDetails: true,
        currentStatus: razorpayrecheckData.transactionStatus

      });

      this.handlefailedRequestAPICall()

      console.log("failed transactions recheck current status::", this.state.currentStatus)

      if (this.state.currentStatus !== "" && this.state.currentStatus !== "undefined") {
        if (this.state.currentStatus === "PENDING") {
          this.props.toggleAlertAction(true, "Transaction Pending, Check status later", 2000, "bg-red");
        } else if (this.state.currentStatus === "TXN_SUCCESS") {
          this.props.toggleAlertAction(true, "Transaction Successful. Check your Account Statement.", 2000, "bg-green");
        } else {
          this.props.toggleAlertAction(true, "Transaction Failed", 2000, "bg-red");
        }

      } else {
        if (razorpayrecheckData.error.message) {
          this.props.toggleAlertAction(true, razorpayrecheckData.error.message, 2000, "bg-red");
        } else {
          this.props.toggleAlertAction(true, "Error", 2000, "bg-red");
        }

      }
    }

  }

  //For handling recheck status of addcash peding case
  handleRechecktrasctionAPI(pgChannel, order_id) {
    this.setState({ orderId: order_id });
    console.log("PG CHANNEL::::", pgChannel, order_id);
    if (pgChannel == "TPSL") {
      this.handleTPSLRechecktrasctionAPI(pgChannel, order_id);
    } else if (pgChannel == "razorpay-pg") {
      this.handleRazorpayRechecktrasctionAPI(pgChannel, order_id);
    } else {
      this.handlejustPayRechecktrasctionAPI(order_id);
    }
  }

  render() {
    return (
      <div style={{position:'sticky', top:'0', minHeight:'100vh', backgroundColor: 'white'}}>
        {/* <nav
          className=" ph2 pv2 tr fixed top-0 left-0 right-0 shadow-4 z-999 "
          style={{ backgroundColor: "#eabf69", color: "#032146" }}
        >
          <div className="w-100  db center ">
            <div className="flex justify-start items-center " >
              <img fill="#ffffff" 
                className="w1"
                src={navarrow}
                alt="no available"
                style={{ width: "25px" }} onClick={this.handlebackbtn} />
              <p className="f4-l f4  mv0 text-medium tc ml2">{TS_STRINGS.KEY_TS_FAILED_TRANSCATIONS}</p>
            </div>
          </div>
        </nav> */}
        {/* <nav className='navbar'>
          <div className="nav-container" >
            <div></div>
            <p className="nav-text" style={{ textAlign: 'center', position:'relative', right:'0' }}>Pending / Failed Transactions</p>
            <img
              className='backBtn'
              src={closeMark}
              style={{ width: "14px", position:'relative', right:'5px' }}
              onClick={this.handlebackbtn}
            />
          </div>
        </nav> */}

        {/* Comment out bottom for sliding transaction summary in wallet page */}
        <nav className='navbar'>
            <div className="nav-container" >
              <img
                className='backBtn'
                src={navarrow}
                style={{ width: "40px" }}
                onClick={this.handlebackbtn}
              />
              <p className="nav-text" style={{ textAlign: 'center', position: 'relative', right: '5px' }}>Pending / Failed Transactions</p>
              <div> </div>
            </div>
          </nav>
          
        <div className="innerSection" style={{backgroundColor:'white'}}>
        <div className="fw6 f6 w-100  center ph3 pb6  mw8" style={{ marginTop: "1rem" }}>
          {this.state.TranscationsList && this.state.isloading ? <Loading /> : this.state.TranscationsList.length ? (

            <div className="bg-white w-100 bb pt1 b--black-10  " >
              <div className="shadow-4 w-100">

                {this.state.TranscationsList && this.state.TranscationsList.map((x, i) => {
                  const t = new Date(x.createdAt)
                  const status = this.getTrasactionType(x.status)
                  console.log("Status:::", status);
                  return <div className="w-100  pv3 fw3 bb b--black-05 striped--near-white" onClick={() => { this.toggleCard(i) }} key={i} >
                    <div className="f6 w-100 flex " >
                      <div className="w-10 tc">{(x.status === "withdraw-processing" && <span > <img
                        fill="#ffffff"
                        className=""
                        src={redeempending}
                        alt="no available"
                        style={{ width: "1rem" }}

                      /></span>)}

                        {((status === "PENDING" || status === "OPEN" || status === "failed") && <span > <img
                          fill="#ffffff"
                          className="  "
                          src={addcashpending}
                          alt="no available"
                          style={{ width: "1rem" }}

                        /></span>)}


                        {(status === "TXN_FAILURE" && <span > <img
                          fill="#ffffff"
                          className=" "
                          src={failed}
                          alt="no available"
                          style={{ width: "1rem" }}

                        /></span>)}

                        {((status === "win_pending") && <span > <img
                          fill="#ffffff"
                          className=" "
                          src={addcashpending}
                          alt="no available"
                          style={{ width: "1rem" }}

                        /></span>)}

                        {((status === "won_forfeited") && <span > <img
                          fill="#ffffff"
                          className=" "
                          src={forfeited}
                          alt="no available"
                          style={{ width: "1rem" }}

                        /></span>)}




                      </div>


                      <div className="w-20 tl" >



                        {x.status && (x.status == "withdraw-processing" || x.status == "win_pending" || x.status == "failed" || x.status == "PENDING") ?
                          (<span className="mv0 f7  dib orange text-bold fw4 ">&#x20B9;{this.checkforIntegerNumber(x.amount) >= 0 ? `${this.checkforIntegerNumber(x.amount)}` : this.checkforIntegerNumber(x.amount).toString().slice(1)}</span>) :
                          (<span className="mv0 f7  dib red text-bold fw4 ">&#x20B9;{this.checkforIntegerNumber(x.amount) >= 0 ? `${this.checkforIntegerNumber(x.amount)}` : this.checkforIntegerNumber(x.amount).toString().slice(1)}</span>)} </div>

                      {/* {(typeof x.amount == 'number' && !isNaN(x.amount)) ? (Number.isInteger(x.amount) ? (<span className={`${(x.status == "TXN_FAILURE" || x.amount < 0) ? 'mv0  f7  dib red text-bold ' : 'mv0 f7  dib orange text-bold '} fw4`}> &#x20B9;
                           {x.amount >= 0 ? `${x.amount}` : x.amount.toString().slice(1)}</span>) : (<span className={`${(x.status == "TXN_FAILURE" || x.amount < 0) ? 'mv0 f7  dib red text-bold ' : 'mv0 f7  dib orange text-bold '} fw4`}> &#x20B9;
                           {x.amount >= 0 ? `${x.amount.toFixed(2)}` : x.amount.toFixed(2).toString().slice(1)}</span>)) : (<span className={`${(x.status == "TXN_FAILURE" || parseInt(x.amount) < 0) ? 'mv0 f7  dib red text-bold ' : 'mv0 f7  dib orange text-bold '} fw4`}> &#x20B9;
                           {parseInt(x.amount) >= 0 ? `${parseInt(x.amount)}` : parseInt(x.amount).toString().slice(1)}</span>)}</div> */}


                      {/* <span className={`${(x.status == "TXN_FAILURE")? 'mv0 ml1 red fw6 ' : 'mv0 ml1  orange text-bold '} fw6`} style={{fontSize:"0.85em"}}>&#8377; {x.amount >= 0 ? `${x.amount}` : x.amount.toString().slice(1)}</span></div> */}
                      <div className="w-40 tl" ><span className="" style={{ color: "#65778E", fontSize: "0.75rem", wordWrap: "break-word", }}>{x.TransactionStatus}</span></div>
                      <div className="w-20 tr"><span className="" style={{ color: "#032146", fontSize: "0.75rem", opacity: "0.8" }}>{`${t.getDate()} ${t.toLocaleString("en-us", { month: "short" })} ' ${t.getFullYear().toString().substr(-2)}`}</span></div>
                      <div className="w-10 tc">
                        {this.state.openCard === i ? <span className="" > <img
                          fill="#ffffff"
                          className=" "
                          src={uparrow}
                          alt="no available"
                          style={{ width: "18px" }}
                        /></span> : <span className=""> <img
                          fill="#ffffff"
                          className=""
                          src={downarrow}
                          alt="no available"
                          style={{ width: "18px" }}
                        /></span>}</div>

                    </div>







                    {this.state.openCard === i && (
                      <div className="w-100 tc ">
                        {(x.status == "PENDING" || x.status === "OPEN") && <div className="center mt2">
                          <div className="center tc ">
                            {x.pgChannel ? (<button className="white br2  center pv1 outline-0 reset-button bw0" style={{ backgroundColor: "#FE9A40" }} onClick={e => this.handleRechecktrasctionAPI(x.pgChannel, x.TransactionObject.order_id)} >{TS_STRINGS.KEY_TS_RECHECK}</button>) : (<button className="white br2  center pv1 outline-0 reset-button bw0" style={{ backgroundColor: "#FE9A40" }} onClick={e => this.handleRechecktrasctionAPI("", x.TransactionObject.order_id)} >{TS_STRINGS.KEY_TS_RECHECK}</button>)}</div>
                          {(this.state.isshowDetails && (x.TransactionObject.order_id == this.state.orderId)) && (
                            <div className="w-100 flex">
                              <span className="w-10"></span>
                              <div className="w-90">
                                <p className="tl mb0"><span className="mv0 " style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_PAYMENT_MODE} </span><span className="mv0 f8 " style={{ color: "#65778E", fontSize: "0.8rem" }}>{x.TransactionObject.mode}</span></p>
                                {x.TransactionObject.order_id && <p className="mb0 mt2 tl" style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_TRANSCATION_ID}  <span className="" style={{ color: "#65778E", fontSize: "0.8rem" }}>{x.TransactionObject.order_id}</span></p>}
                                <p className="tl" style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_TIME}:&nbsp;{`${t.toLocaleString("en-us", { hour: "numeric", minute: "numeric", hour12: true })}`}</p>
                              </div>
                            </div>
                          )}
                        </div>
                        }

                        {(x.status == "win_pending") && <div className="w-100 flex">
                          <span className="w-10"></span>
                          <div className="w-90">
                            <p className="mv0 tl" style={{ color: "#65778E", fontSize: "0.85em" }}>{x.description} </p>
                            {this.state.isPlayStoreChannel
                              ? ((window.sessionStorage["kycStatus"] == "processing" && (window.sessionStorage["panStatus"] == "" || window.sessionStorage["kycDocumentNumber"] == "")) ? (<button className="white mt2 br2 center pv1 tc outline-0 reset-button bw0" style={{ backgroundColor: "#FE9A40" }} onClick={this.showKYCStatusAlert} >{TS_STRINGS.KEY_TS_VERIFY}</button>) : (<button className="white mt2 br2 center pv1 outline-0 reset-button bw0" style={{ backgroundColor: "#FE9A40" }} onClick={() => WebToNativeMessage({ type: "openMyAccount" //verifyPAN //openMyAccount
                              , token: window.sessionStorage["token"] })} >{TS_STRINGS.KEY_TS_VERIFY}</button>))
                              : (window.sessionStorage["kycStatus"] == "processing" ? (<button className="white mt2 br2 center pv1 tc outline-0 reset-button bw0" style={{ backgroundColor: "#FE9A40" }} onClick={this.showKYCStatusAlert} >{TS_STRINGS.KEY_TS_VERIFY}</button>) : (<button className="white mt2 br2 center pv1 outline-0 reset-button bw0" style={{ backgroundColor: "#FE9A40" }} onClick={() => WebToNativeMessage({ type: "openMyAccount" //verifyPAN //openMyAccount
                              , token: window.sessionStorage["token"] })} >{TS_STRINGS.KEY_TS_VERIFY}</button>)
                              )}
                            {/* <button className="white br2 center pv1 outline-0 reset-button bw0" style={{backgroundColor:"#FE9A40"}} onClick={() => WebToNativeMessage({ type: "openMyAccount", token: window.sessionStorage["token"] })} >{TS_STRINGS.KEY_TS_VERIFY}</button>   */}

                          </div>
                        </div>
                        }

                        {(x.status == "won_forfeited") && <div className="w-100 flex">
                          <span className="w-10"></span>
                          <div className="w-90">
                            <p className="mv0 tl" style={{ color: "#65778E", fontSize: "0.85em" }}>{x.description} </p>
                          </div>
                        </div>
                        }

                        {(status == "failed") && <div className="w-100 flex">
                          <span className="w-10"></span>
                          <div className="w-90">
                            <p className="mb0 mt2 tl" style={{ color: "#65778E", fontSize: "0.85em" }}>{TS_STRINGS.KEY_TS_TIME}  <span className="" style={{ color: "#032146", opacity: "0.5" }}>{`${t.toLocaleString("en-us", { hour: "numeric", minute: "numeric", hour12: true })}`}</span></p>
                          </div>
                        </div>
                        }

                        {(x.status == "TXN_FAILURE") && <div >
                          <div className="w-100 flex">
                            <span className="w-10"></span>
                            <div className="w-90">
                              <p className="tl mb0 mt1"><span className="mv0  " style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_PAYMENT_MODE}  </span><span className="mv0  " style={{ color: "#65778E", fontSize: "0.8rem" }}>{x.TransactionObject.mode}</span></p>
                              {x.TransactionObject.order_id && <p className="mb0 mt1 tl" style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_TRANSCATION_ID}  <span className="" style={{ color: "#65778E", fontSize: "0.8rem" }}>{x.TransactionObject.order_id}</span></p>}
                              <p className="tl mt1" style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_TIME}:&nbsp;{`${t.toLocaleString("en-us", { hour: "numeric", minute: "numeric", hour12: true })}`}</p>
                            </div>

                            {/* <span className="w-10"></span> */}
                          </div>
                        </div>
                        }

                        {(x.status == "withdraw-processing") && <div>

                          <div className="w-100 flex">
                            <span className="w-10"></span>
                            <div className="w-90">
                              <p className="tl mb0"><span className="mv0 lh-copy" style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_PAYMENT_MODE} </span><span className="mv0 " style={{ color: "#65778E", fontSize: "0.8rem" }}>{x.TransactionObject.withdrawType}</span></p>
                              {x.TransactionObject._id && <p className="mb0 mt2 tl " style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_TRANSCATION_ID} <span className="tl" style={{ color: "#65778E", fontSize: "0.8rem" }}>{x.TransactionObject._id}</span></p>}
                              {x.TransactionObject.order_id && <p className="mb0 mt2 " style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_TRANSCATION_ID}  <span className="tl" style={{ color: "#65778E", fontSize: "0.8rem" }}>{x.TransactionObject.order_id}</span></p>}
                              <p className="mb0 mt2 tl" style={{ color: "#65778E", fontSize: "0.8rem" }}>{TS_STRINGS.KEY_TS_TIME}  <span className="" style={{ color: "#65778E", fontSize: "0.85rem" }}>{`${t.toLocaleString("en-us", { hour: "numeric", minute: "numeric", hour12: true })}`}</span></p>     </div>
                          </div>

                          {/* <span className="w-10"></span> */}
                        </div>

                        }

                      </div>
                    )}

                  </div>
                })}

              </div>






            </div>

          ) : (
            <div className="center tc">

              <h5 className="flex tc justify-center flex flex-column items-center " style={{ color: "#0F407B", marginTop: "5rem" }}>{TS_STRINGS.KEY_TS_NO_DATA}</h5>

            </div>
          )}


          <div className=" fixed bottom-0 w-100 left-0 right-0  z-9999 bg-white  ">
            {/* {this.state.isuserhaveTDSWinnings && (<div className="bg-washed-red flex justify-around pa1 items-center mb1">
                            <p className="red  " style={{fontSize:"0.7em"}}>Your Winnings are hold until you verify KYC &nbsp; <span className="underline">View details</span> </p>
                            { window.sessionStorage["kycStatus"] == "processing" ? (<button className="white br2 pv1 outline-0 reset-button bw0" style={{backgroundColor:"#FE9A40"}} onClick={() => this.props.toggleAlertAction(true," Your KYC is in pending state please wait until it verified.") } >{TS_STRINGS.KEY_TS_VERIFY}</button> ):( <button className="white br2 pv1 outline-0 reset-button bw0" style={{backgroundColor:"#FE9A40"}} onClick={() => WebToNativeMessage({ type: "openMyAccount", token: window.sessionStorage["token"] })} >{TS_STRINGS.KEY_TS_VERIFY}</button>   ) } 
                        </div>)} */}

            <div className="pb1">

              {this.state.isShowPagination && (
                <ReactPaginate
                  previousLabel={<img className="w1 center" src={rightarrow} />}
                  nextLabel={<img className="w1 center" src={leftarrow} />}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.pageNumbers}
                  marginPagesDisplayed={0}
                  pageRangeDisplayed={3}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              )}
            </div>


          </div>
        </div>
        </div>


      </div>



    )
  }
}
const mapStateToProps = state => ({
  userState: state.userState
});
export default connect(
  mapStateToProps,
  { toggleModalAction, getFailedTranscatiosData, getRecheckFailedTranscatiosData, toggleAlertAction, getTpslRecheckFailedTranscatiosData, getRazorpayRecheckData }
)(FailedTranscations);